S.news =
  {

      config: {
          url: null,
          items: null,
          show: null,
          count: null,
      },
      elements: {
          $button: null,
          $listContainer: null,
          $loadMore: null,
          $itemsShowed: null,

      },
      page: null,
      renewList: true,

      init()
      {

          this.elements.$itemsShowed = 6;
        if (this.elements.$listContainer.attr('data-js-count')<= 6)
        {
          this.elements.$loadMore.hide();
        }
          this.elements.$loadMore.on('click', (e) =>
          {
              this.loadMore();
          });
      },

      getNews()
      {
          const container = this.elements.$listContainer;
          const url = container.attr('url');
          const show = container.attr('data-js-show');
          const allData = {};
          const loadmore = this.elements.$loadMore;
          const count = container.attr('data-js-count');


          allData['tx_project_news[items]'] = this.elements.$itemsShowed;

          $.ajax({
              url: url,
              show: show,
              type: 'POST',
              data: allData,
              success(data)
              {
                  if ($(data).find('.m-button.js-load-more').html())
                  {
                      container.html($(data).find('.m-container').html());
                  }
              },
          });
      },
      loadMore()
      {
          const container = this.elements.$listContainer;
          const count = container.attr('data-js-count');
          const loadmore = this.elements.$loadMore;

          this.elements.$itemsShowed = Number(this.elements.$itemsShowed) + 6;
          if(this.elements.$itemsShowed >= count)
          {
              loadmore.hide();
          }
          this.getNews();
      },
  };
